import { render, staticRenderFns } from "./SearchWeb.vue?vue&type=template&id=0c973086&functional=true&"
import script from "./SearchWeb.vue?vue&type=script&lang=js&"
export * from "./SearchWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports